import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import {
  fetchArtworkRequest,
  fetchArtworkSuccess,
  fetchArtworkFailure,
} from "../reducer/ArtworkViewReducer";

function* fetchArtworkList() {
  try {
    const token = localStorage.getItem("access_token");
    // console.log("token::", token)
    const response = yield call(axios.get,
      "https://dotconnect.dotandkey.com/api/v1/artwork/my", 
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "*/*",
        },
      }
    );
    const artworks = response.data?.data?.items || [];
    yield put(fetchArtworkSuccess(artworks));
    // console.log(response.data)
  } catch (error) {
    yield put(fetchArtworkFailure(error.message || "Failed to fetch artworks"));
  }
}

function* ArtworkViewSaga() {
  yield takeLatest(fetchArtworkRequest.type, fetchArtworkList);
}

export default [ArtworkViewSaga()];
